import React, { useEffect, useState, useCallback } from 'react';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import Spinner from '../../components/components/spinner/spinner';
import { fetchAdminStatistics } from './statisticsService';
import StatisticsDashboard from './StatisticsDashboard';
import './Statistics.css';

const tabsConfig = [
  {
    icon: StatusUp,
    name: 'Statystyki',
    baseClass: 'custom-button-white-buttons-in-row',
    hoverClass: 'hover-effect',
    activeClass: 'is-active',
    onClick: () => {},
  },
];

function Statistics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    fetchAdminStatistics(setData, setLoading, setError);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const buttonsConfig = [
    {
      icon: StatusUp,
      name: 'Odśwież',
      baseClass: 'custom-button-white-buttons-in-row',
      hoverClass: 'hover-effect',
      activeClass: '',
      onClick: load,
    },
  ];

  return (
    <div>
      <Menu />
      <Content>
        <div className="statistics-page-wrapper">
          <LineWithButtons
            tabs={tabsConfig}
            buttons={buttonsConfig}
            rightSide={[]}
          />
          {loading && (
            <div className="statistics-loading">
              <Spinner />
            </div>
          )}
          {error && (
            <div className="statistics-error">
              {error}
            </div>
          )}
          {!loading && !error && data && (
            <StatisticsDashboard data={data} />
          )}
        </div>
      </Content>
    </div>
  );
}

export default Statistics;
